import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Button,
  Card,
  IconButton,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Pagination from "../../components/Pagination";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplyIcon from "@mui/icons-material/Reply";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { errorToast, successToast } from "../../helpers";
import WarnModal from "../../components/modals/WarnModal";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import Loader from "../../helpers/Loader";
import { Forward, Visibility } from "@mui/icons-material";
import ForwardQuary from "../../components/modals/ForwardQuary";
import {
  useLazyDeleteTutorReportQuery,
  useLazyTutorReportQuery,
  useRevertTutorReportMutation,
} from "../../services/tutorReport";
import {
  useRevertTutorChatReportMutation,
  useLazyTutorChatReportQuery,
  useLazyDeleteTutorChatReportQuery,
} from "../../services/tutorChatReport";
import moment from "moment";
import {
  APP_ROLE,
  INQUIRY_REVERT,
  REPORT_CHAT,
} from "../../helpers/constants/enums";
import { formatEnum } from "../../utils/helperFunctions";
import { useNavigate } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageReports = () => {
  // Tutor Report APIs
  const [revertTutorReport] = useRevertTutorReportMutation();
  const [deleteTutorReport] = useLazyDeleteTutorReportQuery();
  const [getTutorReports] = useLazyTutorReportQuery();

  // Chat Report APIs
  const [revertChatReport] = useRevertTutorChatReportMutation();
  const [deleteChatReport] = useLazyDeleteTutorChatReportQuery();
  const [getChatReports] = useLazyTutorChatReportQuery();

  const [revertError, setRevertError] = useState<boolean>(false);
  const [value, setValue] = React.useState(0);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selId, setSelId] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [openForward, setOpenForward] = useState<boolean>(false);
  const [revertQueryInput, setRevertQueryInput] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [openWarn, setOpenWarn] = useState(false);
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
    fetchData(1, debouncedSearchTerm, newValue);
  };

  const handleClose = () => {
    setRevertQueryInput("");

    setOpen(false);
  };

  const fetchData = async (
    page: number,
    search: string,
    tabIndex: number = value
  ) => {
    setLoading(true);
    try {
      let response;
      if (tabIndex === 0) {
        // Fetch tutor reports
        response = await getTutorReports({
          // status: 1,
          page,
          search,
        }).unwrap();
      } else {
        // Fetch chat reports
        response = await getChatReports({
          // status: 1,
          page,
          search,
        }).unwrap();
      }

      setLoading(false);
      if (response.statusCode === 200) {
        setRows(response?.data?.data);
        setTotalCount(response?.data?.total);
      } else {
        setRows([]);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleForwardQuery = async () => {
    setLoading(true);
    try {
      let body = {
        reportId: selId,
        // type: INQUIRY_REVERT.REVERT,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      let response;
      if (value === 0) {
        response = await revertTutorReport({
          body: encryptedBody,
        }).unwrap();
      } else {
        response = await revertChatReport({
          body: encryptedBody,
        }).unwrap();
      }

      setLoading(false);
      if (response.statusCode === 200) {
        successToast(
          value === 0
            ? "Tutor report forwarded successfully"
            : "Chat report forwarded successfully"
        );
        fetchData(page, searchTerm);
        setOpen(false);
      }
    } catch (error: any) {
      setLoading(false);
      console.error(error);
      errorToast(error?.message || "");
    }
  };

  const handleRevertQuery = async () => {
    setLoading(true);
    try {
      let body = {
        revert: revertQueryInput,
        reportId: selId,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      let response;
      if (value === 0) {
        response = await revertTutorReport({
          body: encryptedBody,
        }).unwrap();
      } else {
        response = await revertChatReport({
          body: encryptedBody,
        }).unwrap();
      }

      setLoading(false);
      if (response.statusCode === 200) {
        successToast(
          value === 0
            ? "Tutor report reverted successfully"
            : "Chat report reverted successfully"
        );
        fetchData(page, searchTerm);
        setOpen(false);
      }
    } catch (error: any) {
      setLoading(false);
      console.error(error);
      errorToast(error?.message || "");
    }
  };

  const handleDeeletequery = async (userId: any) => {
    try {
      let response;
      if (value === 0) {
        response = await deleteTutorReport({ id: userId }).unwrap();
      } else {
        response = await deleteChatReport({ id: userId }).unwrap();
      }

      if (response?.statusCode === 200) {
        successToast(
          value === 0
            ? "Tutor report deleted successfully"
            : "Chat report deleted successfully"
        );
        fetchData(page, searchTerm);
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || "");
    }
  };

  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setRows([]);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    fetchData(page, debouncedSearchTerm);
  }, [page, debouncedSearchTerm]);

  const table = (
    <TableContainer className="table_container">
      <Box className="heading"></Box>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">S.No</TableCell>
            {value === 0 ? (
              <>
                <TableCell>Tutor Image</TableCell>
                <TableCell>Tutor Name</TableCell>
                <TableCell>Tutor Email</TableCell>
                <TableCell>Reason</TableCell>
                <TableCell>Parent profile pic</TableCell>
                <TableCell>Parent Name</TableCell>
                <TableCell>Parent Email</TableCell>
              </>
            ) : (
              <>
                <TableCell>Tutor Image</TableCell>
                <TableCell>Tutor Name</TableCell>
                <TableCell>Tutor Email</TableCell>
                <TableCell>Reason</TableCell>
                <TableCell>Report By</TableCell>
                <TableCell>Additional Details</TableCell>
                <TableCell>Parent profile pic</TableCell>
                <TableCell>Parent Name</TableCell>
                <TableCell>Parent Email</TableCell>
              </>
            )}
            <TableCell>Revert Message</TableCell>
            <TableCell>Date & Time</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.length > 0 ? (
            rows?.map((row: any, i: any) => (
              <TableRow key={row?._id}>
                <TableCell align="center">{(page - 1) * 10 + i + 1}</TableCell>
                {value === 0 ? (
                  <>
                    <TableCell>
                      <figure>
                        <img
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: "100%",
                          }}
                          src={row?.tutor?.image || "static/images/logo.png"}
                          alt="Tutor"
                        />
                      </figure>
                    </TableCell>
                    <TableCell>{row?.tutor?.userName || "-"}</TableCell>
                    <TableCell>{row?.tutor?.email || "-"}</TableCell>
                    <TableCell>
                      <Tooltip title={row?.report || "-"} arrow>
                        <span>
                          {row?.reason?.length > 50
                            ? `${row.reason.slice(0, 50)}...`
                            : row?.reason || "-"}
                        </span>
                      </Tooltip>
                    </TableCell>

                    <TableCell>
                      <figure>
                        <img
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: "100%",
                          }}
                          src={row?.parent?.image || "static/images/logo.png"}
                          alt="Parent"
                        />
                      </figure>
                    </TableCell>
                    <TableCell>{row?.parent?.name || "-"}</TableCell>
                    <TableCell>{row?.parent?.email || "-"}</TableCell>
                  </>
                ) : (
                  <>
                    <TableCell>
                      <figure>
                        <img
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: "100%",
                          }}
                          src={row?.tutor?.image || "static/images/logo.png"}
                          alt="tutor"
                        />
                      </figure>
                    </TableCell>
                    <TableCell>{row?.tutor?.userName || "-"}</TableCell>
                    <TableCell>{row?.tutor?.email || "-"}</TableCell>
                    <TableCell>
                      {row?.report ? formatEnum(REPORT_CHAT[row?.report]) : "-"}
                    </TableCell>
                    <TableCell>
                      {row?.reportBy
                        ? formatEnum(APP_ROLE[row?.reportBy])
                        : "-"}
                    </TableCell>
                    <TableCell>
                      {row?.details ? (
                        // Check if it's an image URL
                        /\.(jpg|jpeg|png|gif|webp)$/i.test(row.details) ? (
                          // <Tooltip title={row.screenshot} arrow>
                          <figure>
                            <img
                              style={{
                                width: 50,
                                height: 50,
                                borderRadius: "4px",
                                objectFit: "cover",
                              }}
                              src={row.details || "static/images/logo.png"}
                              alt="Screenshot"
                              onError={(e) => {
                                e.currentTarget.src = "static/images/logo.png";
                              }}
                            />
                          </figure>
                        ) : (
                          // </Tooltip>
                          // Display as text if not an image URL
                          <Tooltip title={row.details} arrow>
                            <span>
                              {row.details.length > 50
                                ? `${row.details.slice(0, 50)}...`
                                : row.details}
                            </span>
                          </Tooltip>
                        )
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>
                      <figure>
                        <img
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: "100%",
                          }}
                          src={row?.parent?.image || "static/images/logo.png"}
                          alt="Reported User"
                        />
                      </figure>
                    </TableCell>
                    <TableCell>{row?.parent?.name || "-"}</TableCell>
                    <TableCell>{row?.parent?.email || "-"}</TableCell>
                  </>
                )}
                <TableCell>{row?.revert || "-"}</TableCell>
                <TableCell>
                  {row?.createdAt ? moment(row.createdAt).format(" lll ") : "-"}
                </TableCell>
                <TableCell>
                  <Box className="table_actions">
                    {value === 1 && (
                      <IconButton
                        onClick={() => {
                          navigate(`/manage-reported/chat/${row?.chatId}`);
                        }}
                        id="abvfd2"
                      >
                        <Visibility />
                      </IconButton>
                    )}
                    <IconButton
                      onClick={() => {
                        setOpen(true);
                        setSelId(row?._id);
                      }}
                      id="abvd2"
                    >
                      <ReplyIcon />
                    </IconButton>
                    {/* <IconButton
                      onClick={() => {
                        setOpenForward(true);
                        setSelId(row?._id);
                      }}
                      id="abvd2"
                    >
                      <Forward />
                    </IconButton> */}
                    <IconButton
                      id="abvd"
                      onClick={() => {
                        setSelectedId(row?._id);
                        setOpenWarn(true);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={value === 0 ? 11 : 12} align="center">
                {value === 0 ? "Tutor Reports" : "Chat Reports"} not found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  let totalPages = Math.ceil(totalCount / 10);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1>Manage Reports</h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Tutor Reports" {...a11yProps(0)} />
              <Tab label="Chat Reports" {...a11yProps(1)} />
            </Tabs>
            <CustomTabPanel value={value} index={0}>
              <Box className="cards_header"></Box>
              {table}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Box className="cards_header"></Box>
              {table}
            </CustomTabPanel>
          </Box>
        </Card>
      </div>

      <Dialog open={open} onClose={handleClose} className="revert_dialog">
        <DialogTitle>
          {value === 0 ? "Revert Tutor Report" : "Revert Chat Report"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="revert-query-input"
            label="Revert Message"
            type="text"
            fullWidth
            sx={{ border: "aliceblue" }}
            value={revertQueryInput}
            onChange={(e) => {
              let value = e.target.value;
              if (value.length === 1 && value === " ") return;
              if (value.length > 200) {
                setRevertError(true);
                return;
              }
              setRevertQueryInput(value);
              setRevertError(false);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button sx={{ background: "#65a442" }} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            sx={{ background: "#65a442" }}
            onClick={handleRevertQuery}
            disabled={revertError || revertQueryInput.trim().length === 0}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>

      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}
      <WarnModal
        open={openWarn}
        setOpen={setOpenWarn}
        handleDelete={() => handleDeeletequery(selectedId)}
        name={value === 0 ? "tutor report" : "chat report"}
      />
      <ForwardQuary
        open={openForward}
        setOpen={setOpenForward}
        handleDelete={() => {
          handleForwardQuery();
        }}
        name={value === 0 ? "tutor report" : "chat report"}
      />
    </MainContainer>
  );
};

export default ManageReports;
